import config from '@/config/config';

import Index from '@/pages/config/company-segment/index.vue';
import List from '@/pages/config/company-segment/list/list.vue';
import View from '@/pages/config/company-segment/view/view.vue';
import New from '@/pages/config/company-segment/new/new.vue';
import Edit from '@/pages/config/company-segment/edit/edit.vue';

const modulePermission = config.modules.companySegment;

export default {
  path: '/company-segment',
  name: 'company-segment',
  component: Index,
  meta: {
    requiresAuth: true,
    modulePermission: modulePermission,
    requiresPermission: 'enabled_read',
  },
  children: [
    {
      path: 'list',
      name: 'company-segment-list',
      component: List,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
    },
    {
      path: ':id',
      name: 'company-segment-view',
      component: View,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_read',
      },
      props: true,
    },
    {
      path: 'new',
      name: 'company-segment-new',
      component: New,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_create',
      },
    },
    {
      path: ':id/e',
      name: 'company-segment-edit',
      component: Edit,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: 'enabled_edit',
      },
      props: true,
    },
  ],
};
